import client from './client';

export const xeroApi = {
  /**
   * Get Xero connection status
   */
  async getStatus() {
    const { data } = await client.get('/api/xero/status');
    return data;
  },

  /**
   * Initiate Xero OAuth2 connection — returns the consent URL
   */
  async connect() {
    const { data } = await client.get('/api/xero/connect');
    return data;
  },

  /**
   * Disconnect Xero (remove stored tokens)
   */
  async disconnect() {
    const { data } = await client.post('/api/xero/disconnect');
    return data;
  },

  /**
   * Search Xero contacts
   */
  async getContacts(search = '') {
    const { data } = await client.get('/api/xero/contacts', {
      params: search ? { search } : {},
    });
    return data;
  },

  /**
   * Get a single Xero contact by ID
   */
  async getContact(contactId) {
    const { data } = await client.get(`/api/xero/contacts/${contactId}`);
    return data;
  },

  /**
   * Get invoices for a Xero contact (with caching)
   */
  async getContactInvoices(contactId, customerId, refresh = false) {
    const params = {};
    if (customerId) params.customerId = customerId;
    if (refresh) params.refresh = 'true';
    const { data } = await client.get(`/api/xero/contacts/${contactId}/invoices`, { params });
    return data;
  },

  async getItems() {
    const { data } = await client.get('/api/xero/items');
    return data;
  },

  async getAccounts() {
    const { data } = await client.get('/api/xero/accounts');
    return data;
  },

  async createInvoiceForCustomer(customerId, payload) {
    const { data } = await client.post(`/api/xero/customers/${customerId}/invoice`, payload);
    return data;
  },
};
